import { useState, useEffect } from 'react';
import { Button, Typography, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setLoadingState } from '../../actions/actions';
import { ButtonGroup } from '..'; 
import '../../common/theme/Legal.scss';
import '../../common/theme/UserFlowPage.scss';
import { saveBackgroundCheck } from '../../common/services/Services';
import HandleFormUtil from '../../common/utilities/HandleFormUtil';

const BackgroundCheckComponent = ({ refreshToken, user, backgroundCheckQuestions, setDisclosureRequired, setCurrentStep, setLegalFlowComplete, openGlobalRestrictedBanner }) => {
  
  const [answers, setAnswers] = useState({});
  const { loaderStyle } = HandleFormUtil(answers, null, null);
  const buttonOptions = ['Yes', 'No'];
  const dispatch = useDispatch();

  useEffect(() => {
    const initialAnswers = {};
    backgroundCheckQuestions.forEach((question) => {
      initialAnswers[question.number] = '';
    });
    setAnswers(initialAnswers);
  }, [backgroundCheckQuestions]);

  const handleAnswerChange = (event, questionKey, answerLabel) => {
    const answer = answerLabel === 'Yes' ? 'Y' : 'N';
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionKey]: answer,
    }));
  };

  const formComplete = () => {
    return Object.values(answers).every((answer) => answer !== '');
  };

  const handleSubmitAndFetchStatus = async () => {
    dispatch(setLoadingState(true));
     const { token } = await refreshToken();
    const payload = {
      answersMap: answers
    };

    try {
      await saveBackgroundCheck(payload, user, token);
      const hasYes = Object.values(answers).some(answer => answer === 'Y');
      if (hasYes) {
        setCurrentStep(3);
        setDisclosureRequired(true);
      } else {
        setLegalFlowComplete(true);
      }
    } catch(error) {
      openGlobalRestrictedBanner(error);
      setLegalFlowComplete(true);
    }

    dispatch(setLoadingState(false));
  };
  
  return (
    <>
      <Typography className='eyebrow'>American Modern | Background questions</Typography>
      <Typography className='title' variant='h4' style={{ fontWeight: 'bold' }}>A few background questions</Typography>
      
      {backgroundCheckQuestions.map((question, index) => (
        <Box key={index} className="selectionBox">
          <Typography>{question.question}</Typography>
          <ButtonGroup
            buttonName={`question${index + 1}`}
            buttons={buttonOptions}
            handleOnChange={(e, buttonLabel) => handleAnswerChange(e, question.number, buttonLabel)}
          />
        </Box>
      ))}
      
      <Box className='continueButton'>
        <Button
          disableRipple
          onClick={handleSubmitAndFetchStatus}
          className='button-styling continue-button mdc-button mdc-button--unelevated amod-theme-blue-100'
          style={loaderStyle}
          disabled={!formComplete()} 
        >
          Continue
        </Button>
      </Box>
    </>
  );
};

export default BackgroundCheckComponent;
